import { render, staticRenderFns } from "./convenienceMenusManageList.vue?vue&type=template&id=37513888&scoped=true"
import script from "./convenienceMenusManageList.vue?vue&type=script&lang=js"
export * from "./convenienceMenusManageList.vue?vue&type=script&lang=js"
import style0 from "./convenienceMenusManageList.vue?vue&type=style&index=0&id=37513888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37513888",
  null
  
)

export default component.exports